import React, { Component } from 'react';
import { Field } from 'redux-form';
import { isEmpty } from '../../FormElement/FormElementUtils';
import TextField from '../../TextField/TextField';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNameFieldDisabled } from '../NameComponentUtil';

export class FirstName extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        isDisabled: PropTypes.bool,
        localePrefix: PropTypes.string.isRequired
    };

    render() {
        const { intl, isDisabled, localePrefix } = this.props;

        return (
            <Field
                id="firstName"
                name="firstName"
                disabled={isDisabled ? 'disabled' : ''}
                required={true}
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="on"
                component={TextField}
                label={intl.formatMessage({id: `${localePrefix}.firstName`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${localePrefix}.NAME_IS_NULL`}))
                ]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    isDisabled: isNameFieldDisabled(state, 'personal-info.firstName')
});

export default connect(mapStateToProps)(injectIntl(FirstName));
